const datalayerTranslate = {
  // TIpos de filtros/facetas:
  status: 'Estado del aviso',
  operationType: 'Tipo de operación',
  realEstateType: 'Tipo de inmueble',
  publicationPlan: 'Tipo de plan',
  location: 'Ubicación',
  province: 'Provincia',
  city: 'Ciudad',
  zone: 'Zona',
  duplicated: 'Avisos duplicados',
  publishedBy: 'Publicado por',
  branches: 'Sucursal',
  // Criterios de ordenamiento:
  modifiedNewer: 'Modificado (Más recientes)',
  modifiedOlder: 'Modificado  (Más antiguos)',
  createdNewer: 'Creado (más reciente)',
  createdOlder: 'Creado (más antiguo)',
  lowerPrice: 'Menor precio',
  higherPrice: 'Mayor precio',
  lowerQuality: 'Menor calidad',
  higherQuality: 'Mayor calidad',
  // Tipos de operacion
  1: 'Venta',
  2: 'Alquiler',
  3: 'Traspaso',
  4: 'Alquiler temporal',
  // Estados de aviso
  ONLINE: 'Activo',
  DRAFT: 'Borrador',
  DELETED: 'Archivado',
  OFFLINE: 'Finalizado',
  ON_HOLD: 'En espera',
  NEAR_END: 'Por vencer',
  WITHOUT_CREDIT: 'Sin crédito',
  // tipos de plan
  FREE: 'Gratis',
  SIMPLE: 'Simple',
  HIGHLIGHTED: 'Destacado',
  SUPERHIGHLIGHTED: 'Super Destacado',
  EXCLUSIVE: 'Exclusive'
};

const getTranslationByKey = key => datalayerTranslate[key] || key;

export { datalayerTranslate, getTranslationByKey };
